module.exports = __webpack_public_path__ + "static/media/Guillermo.c41b2346.jpg";